<template>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" @click="goBack()">×</button>
                <h4 class="modal-title">{{ $t('products') }}</h4>
            </div>
            <div class="modal-body">
                <router-view></router-view>
                <div class="row p-10">
                    <div class="col-md-6 m_md_bottom_15">
                        <button class="btn btn-warning" v-pml-tooltip="$t('refresh')" @click.prevent="refresh" v-pml-block="isRefreshing"><i class="fa fa-refresh"></i></button>
                        <router-link :to="{ name: 'products.create' }" class="btn btn-default">
                            <span class="btn-label">
                                <i class="fa fa-plus-circle"></i>
                            </span>
                            {{ $t('product') }}
                        </router-link>
                        <span class="pull-right m-t-10">{{ $t('data_grid_entries_showing', [list.length]) }}</span>
                    </div>
                    <div class="col-md-6">
                        <input type="text" class="form-control" :placeholder="`${$t('search')}...`" v-model="listConfig.filter">
                    </div>
                </div>
                <div class="over_auto" v-pml-block="isLoading">
                    <table class="table table-striped table-bordered m-0">
                        <thead>
                            <tr>
                                <th class="th_sort" @click.prevent="setOrder('name')" :class="isOrderedColumn('name')">{{ $t('name') }}</th>
                                <th class="th_sort" @click.prevent="setOrder('category_id')" :class="isOrderedColumn('category_id')">{{ $t('category') }}</th>
                                <th class="t_center w_100">{{ $t('active') }}</th>
                                <th class="t_center w_100">{{ $t('actions') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <PmlItem v-for="item in list" :key="item.id" :item="item"></PmlItem>
                            <tr v-show="!list.length">
                                <td class="t_center" colspan="5"><i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import PmlItem from './Item.vue'
    import RoutedModals from 'utils/mixins/routed-modals'
    import TableFilters from 'utils/mixins/table-filters'
    import { trans } from 'utils/helpers/translation'
    import { getAll } from 'services/products'
    import { mapGetters } from 'vuex'

    export default {
        name: 'ProductsModal',
        mixins: [ RoutedModals, TableFilters ],
        components: { PmlItem },
        data () {
            return {
                isRefreshing: false,
                isLoading: false,
                listConfig: {
                    orderProp: 'name',
                    orderDir: 'asc',
                    columns: ['name']
                }
            }
        },
        metaInfo () {
            return {
                title: trans('products')
            }
        },
        computed: {
            ...mapGetters({
                'products': 'getProducts'
            }),
            records () {
                return this.products || []
            }
        },
        methods: {
            refresh () {
                this.isRefreshing = true

                getAll()
                    .then(() => Notify.success(trans('_notifications.success')))
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => { this.isRefreshing = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/parameters/products/components/Main.vue